import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import publicService from './publicService'


const initialState = {
    publicResources: [],
    publicStatus: false,
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: ''
}


//Get recent internal resources by category

export const getRecentInternal = createAsyncThunk('getinternalresourcebycat/getAll', async (_, thunkAPI) => {
    
        try {
            // const token = thunkAPI.getState().auth.user.token;
            return await publicService.getRecentInternal();
        } catch (error) {
            const message  = (error.response && error.response.data && error.response.data.message) || error.message || error.toString() 
            return thunkAPI.rejectWithValue(message);
        }
})


//Get recent internal resources by category

export const getRecentNigeriana = createAsyncThunk('getinternalresources/getAll', async (_, thunkAPI) => {
    
    try {
        // const token = thunkAPI.getState().auth.user.token;
        return await publicService.getRecentNigeriana();
    } catch (error) {
        const message  = (error.response && error.response.data && error.response.data.message) || error.message || error.toString() 
        return thunkAPI.rejectWithValue(message);
    }
})

export const getRecentExternal = createAsyncThunk('getexternalresources/getAll', async (_, thunkAPI) => {
    
    try {
        // const token = thunkAPI.getState().auth.user.token;
        return await publicService.getRecentExternal();
    } catch (error) {
        const message  = (error.response && error.response.data && error.response.data.message) || error.message || error.toString() 
        return thunkAPI.rejectWithValue(message);
    }
})

export const getExternalCategory = createAsyncThunk('externalcategory/getAll', async (_, thunkAPI) => {
    
    try {
        const token = thunkAPI.getState().auth.user.token;
        return await publicService.getExternalCategory(token);
    } catch (error) {
        const message  = (error.response && error.response.data && error.response.data.message) || error.message || error.toString() 
        return thunkAPI.rejectWithValue(message);
    }
})




export const publicSlice = createSlice({
    name: "publicResources",
    initialState,
    reducers: {
        reset: (state) => initialState 
    },
    extraReducers: (builder) => {
        builder
       
    .addCase(getRecentInternal.pending, (state) => {
        state.isLoading = true;
})
    .addCase(getRecentInternal.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.publicResources = action?.payload?.data.results
        // state.resources = action.payload
        
})

    .addCase(getRecentInternal.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
})


    .addCase(getRecentNigeriana.pending, (state) => {
        state.isLoading = true;
    })
    .addCase(getRecentNigeriana.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.publicResources = action?.payload?.data.results
        // state.resources = action.payload
        
    })

    .addCase(getRecentNigeriana.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
    })

    .addCase(getRecentExternal.pending, (state) => {
        state.isLoading = true;
    })
    .addCase(getRecentExternal.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.publicResources = action?.payload?.data.results
        // state.resources = action.payload
        
    })

    .addCase(getRecentExternal.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
    })

    .addCase(getExternalCategory.pending, (state) => {
        state.isLoading = true;
    })
    .addCase(getExternalCategory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.publicResources = action?.payload?.data.results
        // state.resources = action.payload
        
    })

    .addCase(getExternalCategory.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
    })



}

}) 


export const {reset} = publicSlice.actions;
export default publicSlice.reducer;